import{STORE_FULFILLMENT_METHOD}from"../constants";/**
 * Creates the dispatched STORE_FULFILLMENT_METHOD action object.
 * @param {string} method The selected fulfillment method.
 * @returns {Object}
 */var storeFulfillmentMethod=function storeFulfillmentMethod(method){return{type:STORE_FULFILLMENT_METHOD,method:method};};export default storeFulfillmentMethod;